/* unplugin-vue-components disabled */import { render } from "./comp2.vue?vue&type=template&id=f5ca583a&scoped=true"
import script from "./comp2.vue?vue&type=script&lang=js"
export * from "./comp2.vue?vue&type=script&lang=js"

import "./comp2.vue?vue&type=style&index=0&id=f5ca583a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ca583a"]])

export default __exports__